import { getOrigin } from 'forms-utils-lib/utils/window/windowGetters';
const createFullUrlFromHref = href => {
  if (!href.includes('://')) {
    const url = new URL(href, getOrigin());
    return url.href;
  }
  return href;
};
export default createFullUrlFromHref;